'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./view.less');

var _service = require('./service');

var _lodash = require('lodash');

var _next = require('@alifd/next');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _service2 = require('../common/oss-upload-helper/service');

var _validation = require('../common/validation');

var _formFieldUtils = require('../common/formFieldUtils');

var _submit = require('./submit');

var _submit2 = _interopRequireDefault(_submit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Captcha = (_temp = _class = function (_Field) {
  _inherits(Captcha, _Field);

  Captcha.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    //通过errorMs判断手机号校验是否通过
    //isNeedCheck 新增一个字段,判断是否是预填项
    var superState = _Field.getDerivedStateFromProps.call(this, props, state);
    // console.log('getDerivedStateFromProps', superState, props);
    if (!superState) {
      return null;
    }

    superState.isNeedCheck = props.isNeedCheck;

    if (!(0, _lodash.get)(superState, 'fieldData.value', '')) {
      (0, _lodash.set)(superState, 'fieldData.value', {
        phone: '',
        code: '',
        captchaFlag: false,
        cid: '',
        checksum: '',
        passed: false
      });
      return superState;
    }
    if (props.errorMsg && props.errorMsg != props.smsErrorText) {
      (0, _lodash.set)(superState, 'fieldData.value.isFirstStep', false);
    } else if (!props.errorMsg && !(0, _lodash.get)(superState, 'fieldData.value.isFirstStep') && (0, _lodash.get)(superState, 'fieldData.value.phone.length') > 0) {
      (0, _lodash.set)(superState, 'fieldData.value.isFirstStep', false);
      state.firstLoad = false;
    } else {
      (0, _lodash.set)(superState, 'fieldData.value.isFirstStep', true);
    }
    return superState;
  };

  function Captcha(props) {
    _classCallCheck(this, Captcha);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _initialiseProps.call(_this);

    _this.onChange = _this.onChange.bind(_this);
    _this.emitClick = _this.emitClick.bind(_this);
    _this.emitSendSuccess = _this.emitSendSuccess.bind(_this);
    _this.props = {
      phone: ''
    };
    _this.state = {
      defaultFormPropsError: {
        validateState: null,
        help: ''
      },
      formPropsError: {
        validateState: null,
        help: ''
      },
      firstLoad: true,
      hasCaptcha: false,
      hasChange: false,
      cid: '',
      checksum: '',
      passed: false
    };
    return _this;
  }

  Captcha.prototype.componentDidMount = function componentDidMount() {
    _Field.prototype.componentDidMount.call(this);
  };

  Captcha.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-captcha'
    });
  };

  Captcha.prototype.getValue = function getValue(key) {
    var value = (this.state.fieldData || {}).value.phone;
    if (key != 'smsInput') {
      value = (this.state.fieldData || {}).value.code;
    }
    return value;
  };

  Captcha.prototype.getFormProps = function getFormProps(item, props, fieldData) {
    //逻辑有点乱,标示字符有问题,待重构
    var formPropsError = {};
    var style = _extends({}, props.style);
    if (!fieldData.value.isFirstStep) {
      if (item.name == 'smsInput') {
        formPropsError = this.state.defaultFormPropsError;
      } else {
        if (this.state.formPropsError.validateState) {
          formPropsError = this.state.formPropsError;
        } else {
          formPropsError = {};
        }
      }
    } else {
      if (item.name != 'smsInput') {
        formPropsError = this.state.formPropsError;
      }
    }
    if (item.name != 'smsInput') {
      //根据默认值修改
      var isNeedCheck = this.state.isNeedCheck;
      // console.log(isNeedCheck,this.props,fieldData)

      if (isNeedCheck || isNeedCheck === undefined) {
        // style.display = 'flex';
        style.disabled = false;
      } else {
        // style.display = 'none';
        style.disabled = true;
      }
    }
    var formProps = _extends({}, props, { style: style }, { label: item.label }, formPropsError);
    return formProps;
  };

  Captcha.prototype.verifyCaptcha = function verifyCaptcha(value) {
    var _this2 = this;

    var _props = this.props,
        fieldData = _props.fieldData,
        onChangeField = _props.onChangeField,
        fieldId = _props.fieldId,
        global = _props.global;
    var _state = this.state,
        cid = _state.cid,
        checksum = _state.checksum;

    var formPropsError = {
      validateState: 'error',
      help: '验证码错误'
    };

    (0, _service.verifyCaptcha)({
      phone: fieldData.value.phone,
      sequenceNo: (0, _service2.initRequestParams)(fieldId, global).sequenceNo,
      code: value,
      cid: cid,
      checksum: checksum,
      fieldName: fieldId
    }).then(function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      onChangeField({
        captchaFlag: true,
        passed: true,
        cid: cid,
        checksum: checksum
      });
      _this2.setState({ formPropsError: _this2.state.defaultFormPropsError, passed: true });
    }).catch(function () {
      _this2.setState({ formPropsError: formPropsError });
    });
  };

  Captcha.prototype.getFormItemProps = function getFormItemProps() {
    var ret = _Field.prototype.getFormItemProps.call(this);
    var props = this.getProps();
    var hasError = props.hasError,
        errorMsg = props.errorMsg;


    return ret;
  };

  Captcha.prototype.emitClick = function emitClick() {
    this.setState({ hasCaptcha: true });
  };

  Captcha.prototype.emitSendSuccess = function emitSendSuccess() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.setState({ cid: value.cid, checksum: value.checksum });
  };

  Captcha.prototype.renderPhoneNum = function renderPhoneNum(props) {
    var _this3 = this;

    //逻辑扩展性有点差,待更深入代码时,重构
    var _props2 = this.props,
        smsTitle = _props2.smsTitle,
        codeLen = _props2.codeLen,
        fieldData = _props2.fieldData,
        fieldId = _props2.fieldId,
        global = _props2.global,
        isInDetail = _props2.isInDetail;

    var commonProps = this.getControlProps();
    var formList = [];
    var inputProps = _extends({}, commonProps, {
      fieldData: fieldData,
      fieldId: fieldId,
      codeLen: codeLen
    });
    smsTitle.forEach(function (item) {
      var itemValue = _this3.getValue(item.name);
      var itemFormProps = _this3.getFormProps(item, props, fieldData);
      var behavior = _this3.getBehavior();
      var isSmsInput = item.name == 'smsInput';
      var disabled = _this3.state.passed || (0, _lodash.get)(fieldData, 'value.passed');
      // 详情页不需要展示验证码
      if (!isSmsInput && isInDetail) {
        return null;
      }

      var formItem = _react2.default.createElement(
        _next.Form.Item,
        _extends({}, itemFormProps, { key: item.name }),
        behavior === 'READONLY' ? _react2.default.createElement(
          'div',
          { className: 'vc-form-item-view' },
          _Field.prototype.renderDefaultView.call(_this3, itemValue)
        ) : _react2.default.createElement(_next.Input, _extends({}, commonProps, {
          hasClear: false,
          trim: true,
          placeholder: item.placeholder,
          value: itemValue,
          maxLength: isSmsInput ? '' : codeLen,
          disabled: isSmsInput ? commonProps.disabled : disabled,
          innerAfter: isSmsInput ? '' : _react2.default.createElement(_submit2.default, {
            fieldId: fieldId,
            global: global,
            disabled: !!fieldData.value.isFirstStep || _this3.state.firstLoad,
            value: inputProps,
            emitClick: _this3.emitClick,
            emitSendSuccess: _this3.emitSendSuccess
          }),
          onChange: function onChange(val) {
            isSmsInput ? _this3.onChangeSms(item.name, val) : _this3.onChange(item.name, val);
          }
        }))
      );

      formList.push(formItem);
    });
    return formList;
  };

  Captcha.prototype.render = function render() {
    var props = void 0;
    if (window.VisualEngine) {
      props = this.getVeFormItemProps();
    } else {
      props = this.getFormItemProps();
    }

    return _react2.default.createElement(
      'div',
      { className: 'vc-form-item-container' },
      _react2.default.createElement(
        'label',
        _extends({}, props, { style: { paddingLeft: 20 } }),
        props.label
      ),
      this.renderPhoneNum(props)
    );
  };

  return Captcha;
}(_vuFusionField2.default), _class.displayName = 'Captcha', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  fieldId: null,
  label: null
}), _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), [{ name: 'smsErrorText' }, {
  name: 'isNeedCheck',
  formatIn: function formatIn(isNeedCheck, props, input) {
    var isNeedCheckNew = true;
    var fieldData = props.getValue('fieldData');
    if (isNeedCheck || fieldData && (fieldData.value || {}).passed) {
      //联动或passed校验通过之后,不在校验
      isNeedCheckNew = false;
    }
    return isNeedCheckNew;
  }
}, {
  name: 'fieldData',
  formatIn: function formatIn(fieldData, props, input) {
    var fieldDataOld = props.getValue('fieldData');
    var value = {
      phone: '',
      code: '',
      cid: '',
      passed: false,
      checksum: '',
      captchaFlag: false,
      isFirstStep: true
    };
    if (fieldDataOld && fieldDataOld.value) {
      value = _extends({}, value, fieldDataOld.value);
    }
    if (!value.passed) {
      //当校验不通过时,不显示传过来的错误code,并判断当前校验步骤
      value.code = '';

      var _ref = value || {},
          phone = _ref.phone;

      if (!(0, _lodash.isNil)(phone) && (_validation.PATTERN.MOBILE.test(phone) || phone.length === 11 && phone.includes('*'))) {
        value.isFirstStep = false;
      }
    }
    var newFiledData = _extends({}, fieldDataOld, { value: value });
    return newFiledData;
  }
}]), _class.defaultMutators = _extends({}, _vuFusionField2.default.defaultMutators, {
  onChangeField: function onChangeField(_ref2, fieldDataValue) {
    var state = _ref2.state;

    var prevFieldData = state.getValue('fieldData');
    var oldValue = prevFieldData.value;
    var value = _extends({}, oldValue, fieldDataValue);
    var newFiledData = _extends({}, prevFieldData, { value: value });
    state.set('fieldData', newFiledData);
  },
  onChangeCheck: function onChangeCheck(_ref3, value) {
    var state = _ref3.state;

    var prevFieldData = state.getValue('isNeedCheck');
    state.set('isNeedCheck', value);
  }
}), _class.validators = {
  required: {
    valid: function valid(value, param) {
      return value;
    }
  },
  extraValidation: function extraValidation(state, force) {
    var fieldData = state.get('fieldData').getData();
    var phone = fieldData.value.phone;
    var smsErrorText = state.get('smsErrorText').getData();
    var isNeedCheck = state.getData('isNeedCheck');
    var rules = (0, _lodash.get)(state, 'validation.rules', []);
    var errorMsg = null;
    var hasError = false;
    // 非必填则不校验
    if (!(0, _formFieldUtils.checkIsRequired)(rules)) {
      return { errorMsg: errorMsg, hasError: hasError };
    }
    //手机号校验
    if (!(!(0, _lodash.isNil)(phone) && (_validation.PATTERN.MOBILE.test(phone) || phone.length === 11 && phone.includes('*')))) {
      errorMsg = smsErrorText;
      hasError = true;
      return { errorMsg: errorMsg, hasError: hasError };
    }
    //短信校验
    if (!fieldData.value.captchaFlag && isNeedCheck) {
      errorMsg = '请校验验证码';
      hasError = true;
    }
    return { errorMsg: errorMsg, hasError: hasError };
  }
}, _class.propTypes = {
  fieldId: _propTypes2.default.string,
  label: _propTypes2.default.string
}, _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onChange = function (name, value) {
    _this4.forceUpdate();
    _this4.setState({ passed: false });
    var _props3 = _this4.props,
        codeLen = _props3.codeLen,
        onChangeField = _props3.onChangeField;

    onChangeField({
      code: value,
      cid: '',
      checksum: '',
      passed: false
    });
    if (_this4.state.hasCaptcha && value.length == codeLen) {
      _this4.verifyCaptcha(value);
    }
  };

  this.onChangeSms = function (name, value) {
    _this4.setState({ passed: false });
    var _props4 = _this4.props,
        onChange = _props4.onChange,
        onChangeField = _props4.onChangeField,
        onChangeCheck = _props4.onChangeCheck,
        fieldData = _props4.fieldData;

    onChangeCheck(true);
    _this4.setState({ hasChange: true });
    var initValue = {
      phone: value,
      code: '',
      captchaFlag: false,
      cid: '',
      checksum: '',
      passed: false
    };
    onChangeField(initValue);
    _this4.setState({ formPropsError: _this4.state.defaultFormPropsError, firstLoad: false });
    // const newFieldData =Object.assign({}, fieldData,{ phone: value,code: ''})
    var oldValue = fieldData.value;
    var valueNew = _extends({}, oldValue, initValue);
    var newFieldData = _extends({}, fieldData, { value: valueNew });
    onChange(newFieldData);
  };
}, _temp);
exports.default = Captcha;
module.exports = exports['default'];